module.exports = __webpack_public_path__ + "assets/img/m_bdt_img6.4781b602.png";